export function isValueWithKeyInSearchParams(
  key: string,
  value: unknown,
  searchParams: URLSearchParams,
): boolean {
  return value === searchParams.get(key);
}
